export enum AIExtractionErrors {
  noFeatureAccess = 'your_company_does_not_have_access_to_this_feature_yet',
  insufficientCredits = 'you_have_insufficient_ai_credits_to_perform_this_operation',
  exceededDraftLimits = 'you_can_only_have_100_pending_extractions_at_a_time',
}

export const AIExtractionErrorMessages = {
  [AIExtractionErrors.noFeatureAccess]: 'Your company does not have access to this feature yet.',
  [AIExtractionErrors.insufficientCredits]:
    'You have insufficient Autopilot credits to perform this operation.',
  [AIExtractionErrors.exceededDraftLimits]:
    'You can only have 100 pending conversations at a time.',
};
